import React from "react";

export default function CTASection({ onBookDemo }) {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-snaptrix-blue-600 via-purple-600 to-snaptrix-blue-700 text-white text-center relative overflow-hidden" aria-labelledby="cta-heading">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl opacity-10 -ml-36 -mt-36" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl opacity-10 -mr-48 -mb-48" />
      
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <h2
          id="cta-heading"
          className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8 drop-shadow-lg"
        >
          Ready to Transform Your Club's Social Media?
        </h2>
        <p className="text-lg md:text-xl mb-8 md:mb-10 text-white text-opacity-90 max-w-2xl mx-auto">
          Join cricket clubs across the country using Snaptrix to create engaging, professional content in seconds.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <button
            onClick={onBookDemo}
            aria-label="Sign up to get started with Snaptrix"
            className="bg-white text-snaptrix-blue-600 text-lg px-8 py-4 rounded-xl hover:bg-snaptrix-gray-50 transition-all duration-300 hover:scale-105 shadow-2xl hover:shadow-white/20 font-semibold focus:outline-none focus:ring-4 focus:ring-white/50"
          >
            Sign Up
          </button>
          <a
            href="https://app.snaptrix.co.uk/login"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-transparent text-white text-lg px-8 py-4 rounded-xl border-2 border-white/70 hover:border-white hover:bg-white/10 transition-all duration-300 hover:scale-105 font-semibold focus:outline-none focus:ring-4 focus:ring-white/50"
          >
            Log in
          </a>
        </div>
      </div>
    </section>
  );
}
